import { useState, useEffect, useCallback } from "react";
import Letters from "./Letters";
import Board, { freezeLine } from "./Board";
import toast, { Toaster } from "react-hot-toast";
import "./WordOfTheDay.css";
import LinkButton from "../../utils/LinkButton";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import BackToGameList from "../../utils/BackToGameList";

export const saveBoardProgress = (board) => {
  localStorage.setItem("wotdBoardProgress", JSON.stringify(board));
};

export const boardProgress = (tempboard) => {
  if (localStorage.getItem("wotdBoardProgress") === null)
    saveBoardProgress(tempboard);

  return JSON.parse(localStorage.getItem("wotdBoardProgress"));
};

export const getLineProgress = () => {
  if (localStorage.getItem("wotdLineProgress") === null)
    localStorage.setItem("wotdLineProgress", JSON.stringify(1));

  return JSON.parse(localStorage.getItem("wotdLineProgress"));
};

export const changeLineProgress = (i) => {
  localStorage.setItem("wotdLineProgress", JSON.stringify(i));
};

function WordOfTheDay(props) {
  const [letters, setLetters] = useState(null);
  const [letterInputs, setletterInputs] = useState([]);
  const [termsValidation, setTermsValidation] = useState(false);
  const [gameState, setGame] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const [gameOverText, setGameOverText] = useState("");
  let currentLine = getLineProgress();
  let currentCell = 0;

  const setDefaultWord = async () => {
    const response = await makeGetRequest(urls.wotd + "?active=True", "", true);
    const wordList = response.data.map((item) => {
      return item.word;
    });
    const count = Math.floor(Math.random() * wordList.length);
    const wordToSet = wordList[count];
    localStorage.setItem("wotdWord", wordToSet);
  };

  useEffect(() => {
    window.screen.orientation.lock("portrait");
    if (
      localStorage.getItem("wotdWord") == null ||
      localStorage.getItem("wotdWord") == "undefined"
    ) {
      localStorage.removeItem("wotdWord");
      setDefaultWord();
    } else {
    }
  }, []);

  const handleResetGame = () => {
    console.log("Deleting wotd Progress...");
    localStorage.removeItem("wotdBoardProgress");
    localStorage.removeItem("wotdProgress");
    localStorage.removeItem("wotdDate");
    localStorage.removeItem("wotdLineProgress");
    localStorage.removeItem("wotdGameState");
    localStorage.removeItem("wotdWord");
    window.location.reload();
  };

  function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  let alphabet = [
    "q",
    "w",
    "e",
    "r",
    "t",
    "y",
    "u",
    "i",
    "o",
    "p",
    "a",
    "s",
    "d",
    "f",
    "g",
    "h",
    "j",
    "k",
    "l",
    "<<",
    "z",
    "x",
    "c",
    "v",
    "b",
    "n",
    "m",
    ">>",
  ];

  const getLetters = () => {
    var Object = [];
    var id = 0;
    if (localStorage.getItem("wotdProgress") === null) {
      alphabet.map((letter) => {
        if (letter === ">>") {
          id++;
          const status = "UNKNOWN";
          var newObject = { id, letter: "Enter", status };
          Object.push(newObject);
        } else if (letter === "<<") {
          id++;
          const status = "UNKNOWN";
          var newObject = { id, letter: "Backspace", status };
          Object.push(newObject);
        } else {
          id++;
          const status = "UNKNOWN";
          var newObject = { id, letter, status };
          Object.push(newObject);
        }
      });

      localStorage.setItem("wotdProgress", JSON.stringify(Object));
      return Object;
    } else {
      return JSON.parse(localStorage.getItem("wotdProgress"));
    }
  };

  const getLatestLine = () => {
    let id = 0;
    let lineidv = 1;
    for (var b = 0; b <= letterInputs.length; b++) {
      if (!letterInputs[b].frozen) {
        lineidv = letterInputs[id].line;
        break;
      } else {
        id++;
      }
    }
    return lineidv;
  };

  const keyDown = useCallback(
    (event) => {
      if (currentLine !== 6) {
        //currentLine = getLatestLine();
        currentLine = getLineProgress();

        let value = event.key;
        value = value.replace(/[^a-zA-Z]/, "");
        if (event.key === "Shift") {
        } else if (event.key === "Control") {
        } else if (event.key === "Meta") {
        } else if (event.key === "ArrowRight") {
        } else if (event.key === "ArrowLeft") {
        } else if (event.key === "ArrowUp") {
        } else if (event.key === "ArrowDown") {
        } else if (event.key === "-") {
        } else if (event.key === "`") {
        } else if (event.key === "Alt") {
        } else if (event.key === "Tab") {
        } else if (event.key === ".") {
        } else if (event.key === "/") {
        } else if (event.key === ",") {
        } else if (event.key === " ") {
        } else if (event.key > 0) {
        } else if (event.key === "Backspace") {
          if (currentCell != 0) {
            currentCell--;
            document
              .querySelectorAll(
                "[aria-label='" + currentLine + ":" + (currentCell + 1) + "']"
              )[0]
              .focus();
            document.querySelectorAll(
              "[aria-label='" + currentLine + ":" + (currentCell + 1) + "']"
            )[0].value = "";
          } else {
            document
              .querySelectorAll(
                "[aria-label='" + currentLine + ":" + 1 + "']"
              )[0]
              .focus();
          }
        } else if (event.key === "Enter") {
          if (currentLine != 6) {
            var resultWord = "";
            for (var i = 1; i <= 5; i++) {
              resultWord += document.querySelectorAll(
                "[aria-label='" + currentLine + ":" + i + "']"
              )[0].value;
            }
            if (resultWord.length == 5) {
              fetch(
                "https://api.dictionaryapi.dev/api/v2/entries/en/" + resultWord
              )
                .then((res) => {
                  if (!res.ok) {
                    throw Error("Error while fetching data.");
                  }
                  return res.json();
                })
                .then(() => {
                  freezeLine(currentLine);

                  var object = letterInputs;
                  const searchWord = localStorage.getItem("wotdWord");

                  for (var i = 1; i <= 5; i++) {
                    var index = object.findIndex(
                      (obj) => obj.line === currentLine && obj.column === i
                    );
                    object[index].val = document.querySelectorAll(
                      "[aria-label='" + currentLine + ":" + i + "']"
                    )[0].value;
                    object[index].frozen = true;
                  }

                  let bi = 1;
                  for (var c = 0; c < searchWord.length; c++) {
                    var index = object.findIndex(
                      (obj) => obj.line === currentLine && obj.column === bi
                    );

                    if (
                      searchWord.charAt(c) ===
                      document.querySelectorAll(
                        "[aria-label='" + currentLine + ":" + bi + "']"
                      )[0].value
                    ) {
                      object[index].status = "FOUND";
                    } else if (
                      searchWord.includes(
                        document.querySelectorAll(
                          "[aria-label='" + currentLine + ":" + bi + "']"
                        )[0].value
                      )
                    ) {
                      object[index].status = "CONTAINS";
                    }

                    if (
                      object[index].status !== "FOUND" &&
                      object[index].status !== "CONTAINS"
                    ) {
                      object[index].status = "BAD";
                    }
                    bi++;
                  }

                  if (localStorage.getItem("wotdWord") === resultWord) {
                    for (var i = 1; i <= 5; i++) {
                      freezeLine(i);
                    }
                    toast("Good job! The word was " + resultWord, {
                      position: "bottom-center",
                      duration: 10000,
                    });
                    localStorage.setItem("wotdGameState", JSON.stringify(true));
                    setGame(JSON.parse(localStorage.getItem("wotdGameState")));
                    setGameOverText(`Good job! The word was ` + resultWord);
                    setGameOver(true);
                  } else {
                    if (currentLine === 5) {
                      toast(
                        "Sorry you've used all your attempts. Press the Reset Game button at the bottom of the screen to try again!",
                        {
                          position: "bottom-center",
                          duration: 10000,
                        }
                      );
                      localStorage.setItem(
                        "wotdGameState",
                        JSON.stringify(false)
                      );
                      setGameOverText(`Nice Try! The word was ` + searchWord);
                      setGameOver(true);
                    }
                  }

                  setletterInputs(object);
                  saveBoardProgress(letterInputs);

                  checkWord(resultWord);

                  currentLine++;
                  changeLineProgress(currentLine);
                  currentCell = 0;
                })
                .catch((err) => {
                  toast("Word not in dictionary", {
                    position: "bottom-center",
                    duration: 5000,
                  });
                });
            } else {
              toast("Wrong word length", {
                position: "bottom-center",
                duration: 5000,
              });
            }
          }
        } else {
          if (currentCell != 5) {
            currentCell++;
            document.querySelectorAll(
              "[aria-label='" + currentLine + ":" + currentCell + "']"
            )[0].value = value;
            document
              .querySelectorAll(
                "[aria-label='" + currentLine + ":" + currentCell + "']"
              )[0]
              .focus();
          }
        }
      } else {
        toast("Try again tomorrow!", {
          position: "bottom-center",
        });
      }
    },
    [termsValidation]
  );

  useEffect(() => {
    setGame(JSON.parse(localStorage.getItem("wotdGameState")));
    if (gameState == true) {
      var object = letterInputs;
      for (var c = 0; c < letterInputs.length; c++) {
        object[c].frozen = true;
      }
      setletterInputs(object);
    }
  }, [gameState]);

  useEffect(() => {
    setLetters(getLetters());
    document.addEventListener("keydown", keyDown);
    return () => document.removeEventListener("keydown", keyDown);
  }, [keyDown]);

  const loadInitFields = useCallback(async () => {
    const Object2 = [];

    for (var b = 1; b <= 5; b++) {
      for (var c = 1; c <= 5; c++) {
        const newObject = {
          pos: `${b}:${c}`,
          val: "",
          line: b,
          column: c,
          frozen: false,
          status: "UNKNOWN",
        };
        Object2.push(newObject);
      }
    }

    setletterInputs(boardProgress(Object2));
  }, []);

  useEffect(() => {
    loadInitFields();
  }, [loadInitFields]);

  useEffect(() => {
    if (!letters) {
      setTermsValidation(true);
    } else {
      setTermsValidation(false);
    }

    if (!termsValidation) {
    }
  }, [termsValidation]);

  const changeLetter = (letter, status) => {
    var object = letters;
    var index = object.findIndex((obj) => obj.letter === letter);
    object[index].status = status;

    setLetters([...letters, object]);
  };

  const checkWord = (myWord) => {
    if (myWord.length === 5 && !isEmptyOrSpaces(myWord)) {
      for (var i = 0; i < myWord.length; i++) {
        if (myWord.charAt(i) === localStorage.getItem("wotdWord").charAt(i)) {
          changeLetter(myWord.charAt(i).toLowerCase(), "FOUND");
        } else if (
          localStorage.getItem("wotdWord").includes(myWord.charAt(i))
        ) {
          var index = letters.findIndex(
            (obj) => obj.letter === myWord.charAt(i)
          );
          if (letters[index].status !== "FOUND") {
            changeLetter(myWord.charAt(i).toLowerCase(), "CONTAINS");
          }
        } else {
          changeLetter(myWord.charAt(i).toLowerCase(), "BAD");
        }
      }
      localStorage.setItem("wotdProgress", JSON.stringify(letters));
    }
  };

  const addLetter = (e) => {
    let value = e.target.value;
    if (value.match(/[^a-zA-Z]/)) {
      value = value.replace(/[^a-zA-Z]/, "");
      e.target.value = value.toLowerCase();
    } else {
      value = value.replace(/[^a-zA-Z]/, "");
      e.target.value = value.toLowerCase();
    }
  };

  return (
    <>
      <BackToGameList />

      <Container
        style={{
          marginTop: "50px",
          minWidth: "100%",
        }}
      >
        <Card>
          <Row style={{ padding: "25px" }}>
            <div className="wotd">
              <Toaster></Toaster>
              {letterInputs && (
                <Board inputs={letterInputs} addLetter={addLetter}></Board>
              )}
              {!gameOver ? (
                letters && (
                  <Letters
                    keyDown={keyDown}
                    letters={letters}
                    addLetter={addLetter}
                  ></Letters>
                )
              ) : (
                <>
                  <Row style={{ padding: "25px" }}>
                    <b>{gameOverText}</b>{" "}
                    <p style={{ textAlign: "center" }}>
                      Feel free to play again with a new word by pressing the
                      reset game button below!
                    </p>
                  </Row>
                  <LinkButton
                    function={handleResetGame}
                    title="Reset Game"
                  ></LinkButton>
                </>
              )}
            </div>
          </Row>
        </Card>
      </Container>
    </>
  );
}

export default WordOfTheDay;
